import { render, staticRenderFns } from "./MacroAssetsRow.vue?vue&type=template&id=6a8b3c10&"
import script from "./MacroAssetsRow.vue?vue&type=script&lang=js&"
export * from "./MacroAssetsRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports